const SkeletonPage = () => {
  return (
    <div className="reorder-page">
      {[1, 2].map((i) => (
        <div key={i} className="skeleton customer-card">
          <div className="customer-header">
            <div className="user-info">
              <div className="skeleton-circle shimmer"></div>
              <div>
                <div className="skeleton-line shimmer w-120"></div>
                <div className="skeleton-line shimmer w-80"></div>
              </div>
            </div>
          </div>

          <div className="order-card">
            <div className="order-top">
              <div className="skeleton-line shimmer w-100"></div>
              <div className="skeleton-btn shimmer"></div>
            </div>

            {[1, 2, 3].map((j) => (
              <div key={j} className="item-row">
                <div className="skeleton-circle-sm shimmer"></div>
                <div className="skeleton-line shimmer w-160"></div>
                <div className="skeleton-btn-sm shimmer"></div>
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
};

export default SkeletonPage;
